import { render, staticRenderFns } from "./Titulares.vue?vue&type=template&id=410b21e5&"
import script from "./Titulares.vue?vue&type=script&lang=js&"
export * from "./Titulares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports